export default interface ReferralViewModel {
  quoteRef: string;
}

export const mocked_ReferralViewModel_Get: ReferralViewModel = {
  quoteRef: 'Q/CC-000001'
};
